import { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../../Routes';
import AlertContext, { AlertButtonPosition, AlertOnHide, AlertType } from '../../../context/alertContext';
import { useHandleLogoutAfterIdleTime } from '../../../hooks/useHandleLogout';
import { resetShowAlertMessage } from '../../../utils/alertHandling';
import StyledButton from '../../Buttons/StyledButton';
import StyledCol from '../../Cols/StyledCol';
import { RightDiv, SpaceBetweenDiv } from '../../Div/StyledDiv';
import { StyledModal } from '../StyledModal/StyledModal';

const AlertModal = () => {
    const navigate = useNavigate();
    const { alertstate, alertdispatch } = useContext(AlertContext);
    const { handleLogoutAfterIdleTime } = useHandleLogoutAfterIdleTime();
    const [errorType, setErrorType] = useState('info');

    useEffect(() => {
        if (alertstate.alertMessage.alertType !== undefined) {
            if (alertstate.alertMessage.alertType === AlertType.info) {
                setErrorType('info');
            } else if (alertstate.alertMessage.alertType === AlertType.error) {
                setErrorType('danger');
            } else {
                setErrorType('info');
            }
        }
    }, [alertstate.alertMessage]);

    const onHideHandling = () => {
        resetShowAlertMessage(alertdispatch);

        if (
            alertstate.alertMessage.onHide === AlertOnHide.custom &&
            alertstate.alertMessage.onHideCustom !== undefined
        ) {
            alertstate.alertMessage.onHideCustom();
        } else {
            if (alertstate.alertMessage.onHide === AlertOnHide.onlyClose) {
                // do nothing
            } else {
                handleLogoutAfterIdleTime();

                if (alertstate.alertMessage.onHide === AlertOnHide.goToHome) {
                    navigate(Paths.HOME);
                } else if (alertstate.alertMessage.onHide === AlertOnHide.reload) {
                    window.location.reload();
                } else {
                    navigate(Paths.HOME);
                }
            }
        }
    };

    const onHideHandlingSecondary = () => {
        resetShowAlertMessage(alertdispatch);

        if (
            alertstate.alertMessage.onHideSecondary === AlertOnHide.custom &&
            alertstate.alertMessage.onHideCustomSecondary !== undefined
        ) {
            alertstate.alertMessage.onHideCustomSecondary();
        } else {
            if (alertstate.alertMessage.onHideSecondary === AlertOnHide.onlyClose) {
                // do nothing
            } else {
                handleLogoutAfterIdleTime();

                if (alertstate.alertMessage.onHideSecondary === AlertOnHide.goToHome) {
                    navigate(Paths.HOME);
                } else if (alertstate.alertMessage.onHideSecondary === AlertOnHide.reload) {
                    window.location.reload();
                } else {
                    navigate(Paths.HOME);
                }
            }
        }
    };

    const getAlertBody = () => {
        if (alertstate.alertMessage.doHTML) {
            return <div id="alertBody" dangerouslySetInnerHTML={{ __html: alertstate.alertMessage.alertTxt }} />;
        }
        if (alertstate.alertMessage.doBig) {
            return <p style={{ fontSize: '1.5rem' }}>{alertstate.alertMessage.alertTxt}</p>;
        }

        return <p>{alertstate.alertMessage.alertTxt}</p>;
    };

    interface IStyledAlertButton {
        marginLeft?: string;
    }

    const StyledAlertButtonPrimary = (props: IStyledAlertButton) => {
        return (
            <StyledButton
                style={{ marginLeft: props.marginLeft ? props.marginLeft : '0' }}
                onClick={
                    alertstate.alertMessage.switchPrimarySecondaryButton ? onHideHandlingSecondary : onHideHandling
                }
            >
                {alertstate.alertMessage.switchPrimarySecondaryButton
                    ? alertstate.alertMessage.buttonNameSecondary
                    : alertstate.alertMessage.buttonName}
            </StyledButton>
        );
    };

    const StyledAlertButtonSecondary = () => {
        return (
            <StyledButton
                onClick={
                    alertstate.alertMessage.switchPrimarySecondaryButton ? onHideHandling : onHideHandlingSecondary
                }
            >
                {alertstate.alertMessage.switchPrimarySecondaryButton
                    ? alertstate.alertMessage.buttonName
                    : alertstate.alertMessage.buttonNameSecondary}
            </StyledButton>
        );
    };

    const showButtons = () => {
        if (alertstate.alertMessage.buttonNameSecondary && alertstate.alertMessage.onHideSecondary) {
            if (alertstate.alertMessage.alertButtonPosition !== undefined) {
                if (alertstate.alertMessage.alertButtonPosition === AlertButtonPosition.spaceBetween) {
                    return (
                        <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
                            <SpaceBetweenDiv>
                                <div>
                                    <StyledCol textAlign="left" style={{ paddingLeft: 0 }}>
                                        <StyledAlertButtonSecondary />
                                    </StyledCol>
                                </div>
                                <div>
                                    <StyledCol paddingLeft="30px" style={{ paddingRight: 0 }}>
                                        <StyledAlertButtonPrimary marginLeft="20px" />
                                    </StyledCol>
                                </div>
                            </SpaceBetweenDiv>
                        </Container>
                    );
                } else if (alertstate.alertMessage.alertButtonPosition === AlertButtonPosition.right) {
                    return (
                        <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
                            <RightDiv>
                                <StyledAlertButtonSecondary />
                                <StyledAlertButtonPrimary marginLeft="20px" />
                            </RightDiv>
                        </Container>
                    );
                }
            } else {
                return (
                    <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <SpaceBetweenDiv>
                            <div>
                                <StyledCol textAlign="left" style={{ paddingLeft: 0 }}>
                                    <StyledAlertButtonSecondary />
                                </StyledCol>
                            </div>
                            <div>
                                <StyledCol paddingLeft="30px" style={{ paddingRight: 0 }}>
                                    <StyledAlertButtonPrimary marginLeft="20px" />
                                </StyledCol>
                            </div>
                        </SpaceBetweenDiv>
                    </Container>
                );
            }
        }
        return <StyledButton onClick={onHideHandling}>{alertstate.alertMessage.buttonName}</StyledButton>;
    };

    return (
        <StyledModal
            show={alertstate.alertMessage.showModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                {alertstate.alertMessage.doBig ? (
                    <Modal.Title style={{ fontSize: '2rem' }} id="contained-modal-title-vcenter">
                        {alertstate.alertMessage.alertTitle}
                    </Modal.Title>
                ) : (
                    <Modal.Title id="contained-modal-title-vcenter">{alertstate.alertMessage.alertTitle}</Modal.Title>
                )}
            </Modal.Header>
            <Modal.Body>
                <Alert variant={errorType}>{getAlertBody()}</Alert>
            </Modal.Body>
            <Modal.Footer>{showButtons()}</Modal.Footer>
        </StyledModal>
    );
};

export default AlertModal;
